export const API_URL = "https://chat.ekhizmat.tj/api/";
export const SOCKET_API_URL = "https://chat.ekhizmat.tj";
